module.exports = __webpack_public_path__ + "static/img/R4.0635b69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/777/R4.png
// module id = QQc4
// module chunks = 0